import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchPayments = createAsyncThunk(
  'payments/fetchPayments',
  async (filters, { rejectWithValue }) => {
    try {
      return new Promise((resolve) => {
        setTimeout(() => {
          const mockPayments = [
            {
              id: "FF-MNZY1760-KIH3",
              status: "Escrowed",
              statusBg: "blue",
              amount: "$3,200",
              date: "Apr 15, 2026 · 10:45 AM",
              icon: "clock"
            },
            {
              id: "FF-MNZY1760-KIH4",
              status: "Released",
              statusBg: "green",
              amount: "$3,200",
              date: "Apr 15, 2026 · 10:45 AM",
              icon: "tick"
            },
            {
              id: "FF-MNZY1760-KIH5",
              status: "Released",
              statusBg: "green",
              amount: "$3,200",
              date: "Apr 15, 2026 · 10:45 AM",
              icon: "tick"
            }
          ];

          let filtered = [...mockPayments];

          if (filters?.search) {
            filtered = filtered.filter(p =>
              p.id.toLowerCase().includes(filters.search.toLowerCase())
            );
          }

          if (filters?.status && filters.status !== "All Status") {
            filtered = filtered.filter(p => p.status === filters.status);
          }

          resolve({
            status: true,
            data: {
              payments: filtered,
              stats: {
                totalShipments: "1",
                activeShipments: "1",
                pendingShipments: "2",
                completed: "2"
              }
            }
          });
        }, 500);
      });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  payments: [],
  stats: {
    totalShipments: "0",
    activeShipments: "0",
    pendingShipments: "0",
    completed: "0"
  },
  loading: false,
  error: null,
  filters: {
    search: "",
    status: "All Status"
  }
};

const paymentSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setSearchFilter: (state, action) => {
      state.filters.search = action.payload;
    },
    setStatusFilter: (state, action) => {
      state.filters.status = action.payload;
    },
    clearFilters: (state) => {
      state.filters.search = "";
      state.filters.status = "All Status";
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload.data.payments;
        state.stats = action.payload.data.stats;
      })
      .addCase(fetchPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSearchFilter, setStatusFilter, clearFilters, clearError } = paymentSlice.actions;
export default paymentSlice.reducer;